import { Reducer } from 'redux';
import { IMatzevaState } from 'types/matzeva.types';
import * as authConstants from '../constants/auth.constants';
import * as constants from '../constants/matzeva.constants';

export const defaultState: IMatzevaState = {
  cementeries: {},
  count: 0,
  items: [],
  loading: false,
  selectedItem: null,
  table: {
    page: 1,
    limit: 10,
    search: '',
    sortKey: 'id',
    sortType: 'asc',
  },
};

const matzevaReducer: Reducer = (state = defaultState, action) => {
  const { data, type } = action;
  switch (type) {
    case constants.MATZEVA_ON_DELETE_REQUESTED:
    case constants.MATZEVA_ON_GET_ALL_REQUESTED:
    case constants.MATZEVA_ON_GET_FORM_REQUESTED:
    case constants.MATZEVA_ON_SAVE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case constants.MATZEVA_ON_GET_ONE_REQUESTED:
      return {
        ...state,
        loading: !!action.id,
        selectedItem: null,
      };
    case constants.MATZEVA_ON_GET_ALL_SUCCEEDED:
      return {
        ...state,
        count: data.count,
        items: data.items,
        loading: false,
        table: data.table,
      };
    case constants.MATZEVA_ON_GET_FORM_SUCCEEDED:
      return {
        ...state,
        cementeries: data.cementeries,
        loading: false,
      };
    case constants.MATZEVA_ON_GET_ONE_SUCCEEDED:
      return {
        ...state,
        loading: false,
        selectedItem: data.item,
      };
    case constants.MATZEVA_ON_DELETE_SUCCEEDED:
    case constants.MATZEVA_ON_SAVE_SUCCEEDED:
    case constants.MATZEVA_ON_DELETE_FAILED:
    case constants.MATZEVA_ON_GET_ALL_FAILED:
    case constants.MATZEVA_ON_SAVE_FAILED:
      return {
        ...state,
        loading: false,
      };
    case constants.MATZEVA_ON_GET_FORM_FAILED:
      return {
        ...state,
        cementeries: {},
        loading: false,
      };
    case constants.MATZEVA_ON_GET_ONE_FAILED:
      return {
        ...state,
        loading: false,
        selectedItem: null,
      };
    case authConstants.AUTH_ON_LOGOUT_SUCCEEDED:
    case authConstants.AUTH_ON_LOGOUT_PUBLIC_SUCCEEDED:
      return defaultState;
    default:
      return state;
  }
};

export default matzevaReducer;
